import * as _ from "lodash";

import { IExecutionState, IStep } from "../../processDetails/Models";
import * as TestProcessActions from "../actions/TestProcessActions";
import { IAction } from "../model/IAction";

export function testProcess(state: ITestProcess = { testExecutionId: null, executions: [] }, action: IAction): ITestProcess {
    switch (action.type) {
        case TestProcessActions.TEST_PROCESS_STARTED: {
            const testProcessStartedAction = action as TestProcessActions.ITestProcessStartedAction;
            const stateCopy: ITestProcess = _.cloneDeep(state);
            stateCopy.testExecutionId = testProcessStartedAction.testExecutionId;
            stateCopy.executions.unshift({ result: null, selectedTaskId: testProcessStartedAction.selectedTaskId, parameters: testProcessStartedAction.parameters });
            return stateCopy;
        }

        case TestProcessActions.TEST_PROCESS_COMPLETED: {
            const testProcessCompleted = action as TestProcessActions.ITestProcessCompletedAction;
            const stateCopy: ITestProcess = _.cloneDeep(state);
            if (testProcessCompleted.result.state !== IExecutionState[IExecutionState.Started]) {
                // Setting executionId to null will stop the fetching for this process
                stateCopy.testExecutionId = null;
            }
            const step = testProcessCompleted.result;
            stateCopy.executions[0].result = step;
            return stateCopy;
        }
        case TestProcessActions.TEST_PROCESS_CANCELED: {
            // Setting executionId to null will stop the feching for this process
            return Object.assign({}, state, { testExecutionId: null });
        }
        default:
            return state;
    }
}

export interface ITestProcess {
    testExecutionId: string | null;
    executions: ITestProcessExecution[];
}

export interface ITestProcessExecution {
    result: IStep | null;
    parameters: any;
    selectedTaskId: string;
}
